<template>
	<div class=" DashboardMain content">
		<!-- div class="Dashboard-row" >
			<div class="col-sm-6 col-xs-12 mb-4">
				<div  class="telega-container mb-3 blink-1">
					<i class="tim-icons icon-alert-circle-exc text-danger mb-2"></i>
					<h6>!!! Не забудьте пополнить рекламный счёт, выбрать и оплатить пакет на следующий месяц !!!</h6> 
				</div>
			</div>
		</div -->
		<div class="Dashboard-row" v-if="typeof objStaffExtra[myProfile.code] !='undefined' && ( typeof objStaffExtra[myProfile.code].telegram_id=='undefined' || objStaffExtra[myProfile.code].telegram_id==0 || objStaffExtra[myProfile.code].telegram_active==0)">
			<div class="col-sm-6 col-xs-12 mb-4">
				<!-- <div v-if="myProfile.telegram_active == 1" class="telega-container">
					<h6>Телеграм подключен</h6> 
				</div> -->
				<div  class="telega-container">
					<i class="tim-icons icon-alert-circle-exc text-danger mb-2"></i>
					<h6>  Телеграм не подключен. Подпишитесь на уведомления в телеграм</h6> 
					<a class="btn btn-simple btn-primary" :href="'/data/staff/id/'+ myProfile.code +'/settings'">Подписаться</a>
				</div>
			</div>
		</div>
		<!-- <div class="Dashboard-row">
			<div class="col-sm-6 col-xs-12 mb-4">
				<a href="/data/clients" class="menu-card">
					<i class="tim-icons icon-single-02"></i>
					<h6 class="menu-card-title mt-2">Клиенты</h6>
				</a>
			</div>
			<div class="col-sm-6 col-xs-12 mb-4">
				<a href="/data/tasks" class="menu-card">
					<i class="tim-icons icon-notes"></i>
					<h6 class="menu-card-title mt-2">Задачи</h6>
				</a>
			</div>
			<div class="col-sm-6 col-xs-12 mb-4">
				<a href="/data/module/sso" class="menu-card">
					<i class="tim-icons icon-square-pin"></i>
					<h6 class="menu-card-title mt-2">Объекты</h6>
				</a>
			</div>
			<div class="col-sm-6 col-xs-12 mb-4">
				<a href="/data/staff" class="menu-card">
					<i class="tim-icons icon-badge"></i>
					<h6 class="menu-card-title mt-2">Сотрудники</h6>
				</a>
			</div>
		</div> -->

		<!-- <div><RePhoneBar /></div> -->
		
		<div class="Moderation-row ">
			<div class="col-sm-4 col-xs-12 mb-4 px-0">
				<div  class="Moderation card">
					<div class="Moderation-top mb-3">
						<i class="tim-icons icon-square-pin mb-2"></i>
						<h6 class="mb-0">Проверка объектов</h6>
					</div>
					<a href="/data/module/mo?dSearchType=mobj&srv_new=1&srv_inwork=1&moderation_status=1" class="Moderation-item py-2">
						<div class="d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center justify-content-between">
								<i class="tim-icons icon-alert-circle-exc text-info mr-2"></i>
							
								<h6 class="menu-card-title mt-2">Не проверено: </h6>
								
							</div>
							<h6 class="menu-card-title mt-2">{{ objNotModerated }}</h6>
						</div>
					</a>
					<a href="/data/module/mo?dSearchType=mobj&srv_new=1&srv_inwork=1&moderation_status=3" class="Moderation-item py-2">
						<div class="d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center justify-content-between">
								<i class="tim-icons icon-simple-remove text-danger mr-2"></i>
							
								<h6 class="menu-card-title mt-2">Отклонено: </h6>
							</div>
							<h6 class="menu-card-title mt-2">{{ objCanceled }}</h6>
						</div>
					</a>
					<a href="/data/module/mo?dSearchType=mobj&srv_new=1&srv_inwork=1&moderation_status=2" class="Moderation-item pt-2">
						<div class="d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center justify-content-between">
								<i class="tim-icons icon-check-2 text-success mr-2"></i>
							
								<h6 class="menu-card-title mt-2">Принято: </h6>
								
							</div>
							<h6 class="menu-card-title mt-2">{{ objAccepted }}</h6>
						</div>
					</a>
					
				</div>
			</div>
		</div>

		

		<div class="masServices">
			<!--template v-if="typeof masApi.anal !='undefined'"-->
			<template>
				<div class="d-flex  align-items-center"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/><h6 class="ml-3">Выберите услуги для вывода в фильтре</h6></div>
				<div class="row mb-3" v-show="bShowFilter">
					<div class="col-12">
						<ReFilter :masAllFilterParams="masAllFilterParams" 
						v-model="objGetParams" 
						v-on:filterapply="OnFilterApply"
						name="dashboardanal"/>
					</div>
				</div>
				
				<ReDashService class="mb-4" v-for="service in masApi.anal" :key="service.id" :objService="service"/>
				
			</template>
			<!--collapse class="w-100 border-right-0">
				<collapse-item title="Аналитика по услугам / Воронка продаж" @activate="getApi('collapse')" :activeIndex="activeS">

				<template v-if="typeof masApi.anal !='undefined'">
					<div><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/></div>
					<div class="row mb-3" v-show="bShowFilter">
						<div class="col-12">
							<ReFilter :masAllFilterParams="masAllFilterParams" 
							v-model="objGetParams" 
							v-on:filterapply="OnFilterApply"
							name="dashboardanal"/>
						</div>
					</div>
					<ReDashService class="mb-4" v-for="service in masApi.anal" :key="service.id" :objService="service"/>
					
				</template>
					
				</collapse-item>
			</!--collapse-->
		</div>

		<!-- <pre>{{ myProfile }}</pre>  -->

		
		
	</div>
	
</template>
<script>
import {eventEmitter} from "src/plugins/globalComponents.js";
// import LineChart from '@/components/Charts/LineChart';
// import BarChart from '@/components/Charts/BarChart';
// import * as chartConfigs from '@/components/Charts/config';
// import TaskList from './TaskList';
// import UserTable from './UserTable';
// import StatsCard from 'src/components/Cards/StatsCard';
// import config from '@/config';
// import ReBranchPrint from 'src/our_components/ReBranchPrint.vue';
// import ReTree from 'src/our_components/Tree/ReTree.vue';
import ReDashService from 'src/our_components/ReDashService.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import { Collapse, CollapseItem } from 'src/components';
// import { ThirdPartyDraggable } from "@fullcalendar/interaction";

// import RePhoneBar from 'src/our_components/RePhoneBar.vue';

export default {
	components: {
		// LineChart,
		// BarChart,
		// StatsCard,
		// TaskList,
		// UserTable,
		// ReBranchPrint,
		// ReTree,	
		ReDashService,
		ReFilter,
		ReFilterBtn,
		// Collapse, 
		// CollapseItem,
		// RePhoneBar,
	},
	data() {
		return {
			masTree:[],
			masApi:[],
			masModeration:[],
			objNotModerated: '???',
			objCanceled: '???',
			objAccepted: '???',
			cp:[],
			tabs: {
				activeIndexStyle: 0,
				tabStyle: [
					{ name: "Сегодня", icon: "tim-icons icon-kanban"},
					{ name: "Вчера", icon: "d-inline-block icon-calendar-day" },
					{ name: "Неделя", icon: "d-inline-block icon-calendar-week" },
					{ name: "Месяц", icon: "d-inline-block icon-calendar-month" }
				],
				activeIndexView: 1,
				tabView: [
					{ name: "Все", icon: "d-inline-block icon-group" },
					{ name: "Мои", icon: "tim-icons icon-user-run" },
					{ name: "Сотрудник", icon: "tim-icons icon-single-02" }
				]
			},
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			bShowFilter: false,
			activeS: -1,
			objStaffExtra:{},
		};
	},
	computed: {
		enableRTL() {
			return this.$route.query.enableRTL;
		},
		isRTL() {
			return this.$rtl.isRTL;
		},
		myProfile(){
			return this.$GVO.my_profile;
		},
	},
	methods: {
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_SERVICE_ANAL',{obj:'services'})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			//this.objGetParams = data;
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			// console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApi();
		},
		getTree(){
			this.$GVO.ApiCall('GET',{obj:'tree' ,flt:{id:'624B713D-2ADE-11E3-AC8E-001E67065AB1'} })
			.then((objApi) => { 
				if(objApi.success === true){ //console.log(objApi);
					this.masTree = objApi.data;
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		TreeSetElementModel(e){
		    alert(e);
		},
		initTabStyle(index) {
			this.tabs.activeIndexStyle = index;
		},
		initTabView(index) {
			this.tabs.activeIndexView = index;
		},
		getApi(flag){
			if(flag==='collapse' && typeof this.masApi.anal !== 'undefined'){return false;}

			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}
			//console.log('getApi',filter);
			this.$GVO.ApiCall('GET_SERVICE_DESC_ANAL',{obj:'services' ,flt:{...filter} })
			//this.$GVO.ApiCall('GET_SERVICE_DESC_ANAL',{obj:'services' })
			.then((objApi) => { 
				if(objApi.success === true){ //console.log(objApi);
					this.masApi = objApi.data;
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		getObjects(){
			//console.log('getApiData = MyObj.GET', this.$route.params.object_id);
			this.masModeration = [];
			let filters = function(flt){
				return Object.assign({
					'list':true,
					c2p:1,
					// фильтры из объекта
					"srv_new":"1",
					"srv_inwork":"1",
					"dSearchType":"mobj"
				},flt)
			}
			let apiModerate = (status)=>{
				return this.$GVO.ApiCall('MyObj.GET',{flt:filters({"moderation_status": status})})
			}
			apiModerate("1")
			.then((objApi) => {
				if(objApi.success === true){
					this.objNotModerated = objApi.total
					/*
					if(objApi.data.length > 0){
						this.masModeration = objApi.data;
						for(let i = 0; i < this.masModeration.length; i++)
						if(this.masModeration[i].moderation_status_id == 3) {
							this.objCanceled ++;
						}else if (this.masModeration[i].moderation_status_id == 2){
							this.objAccepted ++;
						}else if (this.masModeration[i].moderation_status_id == 1){
							this.objNotModerated ++;
						}
					}
					*/
				}
				return apiModerate("3")
			}).then((objApi) => {
				if(objApi.success === true){
					this.objCanceled = objApi.total
				}
				return apiModerate("2")
			}).then((objApi) => {
				if(objApi.success === true){
					this.objAccepted = objApi.total
				}
			}).catch(errorObjApi => {this.masModeration = []; console.error(errorObjApi); });
		},
		checkTelegram(){
			// this.masObjects = JSON.parse(this.value);
			// if(this.value!='' && this.value!=undefined){
			// 	this.masObjects = JSON.parse(this.value);
			// 	for (let i = 0; i < this.masObjects.length; i++) {
					
			// 	}
			// }
			if(typeof this.objStaffExtra[this.$GVO.my_profile.code] == 'undefined'){
						this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.$GVO.my_profile.code}})
						.then((objApi) => {
							if(objApi.success === true){
								this.objStaffExtra[this.$GVO.my_profile.code] = objApi.data[0];
							}
						}).catch(errorObjApi => {console.error(errorObjApi);});
					}

			//console.log('this.masObjects',this.masObjects);
		},

	},
	mounted() {
		this.i18n = this.$i18n;
		if (this.enableRTL) {
			this.i18n.locale = 'ru';
			this.$rtl.enableRTL();
		}
		//this.getApi();
		this.getObjects();
		this.checkTelegram();
	},
	beforeDestroy() {
		if (this.$rtl.isRTL) {
			this.i18n.locale = 'ru';
			this.$rtl.disableRTL();
		}
	}
};
</script>
<style scoped>
.masServices .bntGroup {display: flex; justify-content: center;}
.servicesTabs {display: flex; justify-content: center; margin-bottom: 30px; flex-wrap: wrap;}
.masServices >>> .btn-primary.active {background-color:#01B0E0!important;}

.menu-card, .Moderation {border: 1px solid #01b0e0; border-radius: 6px; padding: 15px; width: 100%; align-items: center; display: flex; flex-direction: column;}
.menu-card:hover {box-shadow: 0px 0px 10px rgb(1 176 224 / 50%)}
.DashboardMain .Dashboard-row >>> .tim-icons, .Moderation-top >>> .tim-icons {font-size: 30px;}
.Moderation-item >>> .tim-icons {font-size: 20px;}
.Moderation-item {width: 100%; padding: 0 7px;}
.Moderation-item:hover {background-color: #9e77f350;}
.Moderation-item:not(:last-child) {border-bottom: 1px solid #9e77f3;}
.Dashboard-row, .Moderation-row {display: flex; flex-wrap: wrap;}

.DashboardMain >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}

.Moderation, .Moderation-top {border: 1px solid #9e77f3; border-radius: 6px; padding: 15px; width: 100%; align-items: center; display: flex; flex-direction: column;}
.Moderation-top  {background-color: #9e77f3; color: white; width: 100%; }
.Moderation-top h6 {color: white;}

.icon-kanban {
	background-image: url('/img/icons/kanban.svg');
	background-repeat: no-repeat;
	width:16px;
	height: 16px;
	margin-top: 2px;
}
.icon-calendar-day {
	background-image: url('/img/icons/calendar-day.svg');
	background-repeat: no-repeat;
	width:16px;
	height: 16px;
	margin-top: 2px;
}
	.icon-calendar-week {
	background-image: url('/img/icons/calendar-week.svg');
	background-repeat: no-repeat;
	width:16px;
	height: 16px;
	margin-top: 2px;
}
	.icon-calendar-month {
	background-image: url('/img/icons/calendar-month.svg');
	background-repeat: no-repeat;
	width:16px;
	height: 16px;
	margin-top: 2px;
}
	.icon-group {
	background-image: url('/img/icons/group.svg');
	background-repeat: no-repeat;
	width:22px;
	height: 14px;
	margin-top: 2px;
}

.telega-container {
	border: 1px dashed #F84E54; border-radius: 6px; padding: 15px; width: 100%;  align-items: center; display: flex; flex-direction: column; 
}

.blink-1 {
  animation-name: blink;
  animation-timing-function: linear;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.blink-2 {
  animation-name: blink;
  animation-timing-function: linear;
  animation-duration: 0.3s;
  animation-iteration-count: infinite;  
}
@keyframes blink {
  50% {
    /* opacity: 0; */
	border-color: white;
  }
}

</style>
